export class AppSettings {
  public apiUri?: string;
  public menus?: MenuSettings;
  public title?: string;
  public version?: string;
  public authorityUri: string;
  public appCode: string;
  public enableAuthLogging: boolean;
  public scopes: string[];
}

export class MenuSettings {
  public header?: HeaderMenuSettings[];
  public footer?: FooterMenuSettings[];
}

export class HeaderMenuSettings {
  public name?: string;
  public route?: string;
}

export class FooterMenuSettings {
  public name?: string;
  public link?: string;
}



// WEBPACK FOOTER //
// ./src/core/models/appSettings.model.ts